import { computed } from 'vue';
import { Info, TriangleAlert, CircleX, Download, Bell } from 'lucide-vue-next';
export function useNotificationType(type) {
    /**
     * Type (color) of the notification based on notification.jobType
     */
    const notificationType = computed(() => {
        switch (type) {
            case 'Info':
                return 'info';
            case 'Warning':
                return 'warning';
            case 'Error':
                return 'error';
            case 'FileDownload':
                return 'file-download';
            default:
                return 'info';
        }
    });
    /**
     * Specified icon based on type
     */
    const icon = computed(() => {
        switch (notificationType.value) {
            case 'info':
                return Info;
            case 'warning':
                return TriangleAlert;
            case 'error':
                return CircleX;
            case 'file-download':
                return Download;
            default:
                return Bell;
        }
    });
    return {
        notificationType,
        icon
    };
}
